import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import AlertTitle from '@material-ui/lab/AlertTitle';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import CloseIcon from '@material-ui/icons/Close';

// STYLES
import { StyledAlert } from './styles';

function AlertWarning({ className, title, message, hasCloseAction, hasTitle, open, onClose }) {
  const [t] = useTranslation();

  return (
    <Collapse in={open}>
      <StyledAlert
        severity="warning"
        iconMapping={{ error: <WarningRoundedIcon /> }}
        className={clsx('alert-warning', className)}
        action={
          hasCloseAction && (
            <IconButton aria-label="close" color="inherit" onClick={onClose}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          )
        }
      >
        {hasTitle && <AlertTitle variant="h5">{title || t('common.smthWentWrong')}</AlertTitle>}
        <p className="p4">
          <Trans>{message}</Trans>
        </p>
      </StyledAlert>
    </Collapse>
  );
}

AlertWarning.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  open: PropTypes.bool,
  hasCloseAction: PropTypes.bool,
  hasTitle: PropTypes.bool,
  onClose: PropTypes.func,
};

AlertWarning.defaultProps = {
  open: true,
  hasCloseAction: false,
  hasTitle: true,
  onClose: () => {},
};

export default React.memo(AlertWarning);
